import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 md:py-24" aria-labelledby="faq-title" data-id="element-114" data-mp="122vbicn8knnw">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="1psprh32uqscd">
        <SectionHeading title={<span id="faq-title" data-id="element-117" data-mp="1urk6rv1m1yrq">Frequently asked questions</span>} data-id="element-116" data-mp="1uraoyuqpyxx4" />

        <div className="mt-10 divide-y divide-sand border-y border-sand" data-id="element-118" data-mp="1ut54tun4vzuc">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-119" data-mp="1kzo7whrpa4mg" data-mpi={i}>
                <h3 data-id="element-120" data-mp="28r1zumlxvy6w">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500" data-id="element-121" data-mp="28qju8zde07mb">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-122" data-mp="2yi4rw2s1mbi1" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-123" data-mp="32hdqbky12xjx">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-124" data-mp="3hee4smr7kw0g">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-125" data-mp="27rigyswliup5">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-12" data-id="element-126" data-mp="2gsyqkyfl6ssb">
          <CtaButton label="Get instant access now" data-id="element-127" data-mp="2lq8gsgasv8h7" />
        </div>
      </div>
    </section>;
}